<ng-container button>
    <button (click)="onLogIn()" class="vl-button vl-button--icon-before mdk-login-button">
        <i class="vl-button__icon vl-button__icon--login vl-button__icon--before vl-vi vl-vi-burgerprofiel"
            aria-hidden="true"></i>
        <span class="vl-button__label">AANMELDEN</span>
    </button>
</ng-container>